var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1481_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25781 5.21753H10.7188V21.6785H17.2812V5.21753H19.7422L14 0.295654L8.25781 5.21753Z",
    fill: "#A12B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0234 15.116H24.6641L20.5625 10.1949L18.9219 12.1634V21.6785H23.0234V15.116Z",
    fill: "#A12B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07812 21.6785V12.1634L7.4375 10.1949L3.33594 15.116H4.97656V21.6785H9.07812Z",
    fill: "#A12B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0189 23.3191L21.4795 28.2957H28L23.8442 23.3191H19.0189Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8159 23.3191L8.35504 28.2957H19.6449L17.1844 23.3191H10.8159Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98138 23.3191H4.15587L0 28.2957H6.52066L8.98138 23.3191Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1481_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.295654)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.030521744106d2a5d38c2a87a7ce2ac3.svg";
export { ForwardRef as ReactComponent };